export { default as EmailCapture } from './EmailCapture';
